import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Countdown from './Countdown';
import './EventDetails.css';

const EventDetails: React.FC = () => {
  const [activeTab, setActiveTab] = useState('pre-fiesta');

  return (
    <>
      {/* First Block (Top Half) */}
      <section className="event-details-block-one pt-0 pb-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-center">
              <img src="/images/couple_embracing.jpg" alt="Couple Embracing" className="img-fluid width-75" />
            </div>
            <div className="col-md-6 text-center text-md-start">
              <h2 className="title-text cursive-heading mb-4">we're getting married!</h2>
              <Countdown />
              <p className="content-text mb-4">
                And thought to ourselves, let's do it on an island we have never been to with all our favorite people.
              </p>
              <Link to="/our-story" className="btn-like-tab">Read Our Story</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Second Block (Bottom Half) */}
      <section className="event-details-block-two pt-0 pb-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12">
              <h2 className="title-text mb-3">Wedding week</h2>
              <p className="content-text mb-4">
                The wedding is Friday, October 2nd with formal wedding events Thursday, October 1st through Saturday, October 3rd. Morgan & Lance have rented out their venue exclusively which includes 49 rooms for their guests for Thursday and Friday night.
              </p>
              <p className="content-text mb-4">
              We hope you will take the opportunity to turn our fiesta into your own vacation. Morgan and Lance will be spending the week before on the island beaching, hiking, and eating a few too many tapas. They would love for you to join them for any or all of the week leading up to the formal wedding events (pre-fiesta).
              </p>

              <ul className="nav nav-tabs mb-4">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'pre-fiesta' ? 'active' : ''}`}
                    onClick={() => setActiveTab('pre-fiesta')}
                  >
                    pre-fiesta
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'fiesta' ? 'active' : ''}`}
                    onClick={() => setActiveTab('fiesta')}
                  >
                    fiesta
                  </button>
                </li>
              </ul>

              {activeTab === 'pre-fiesta' && (
                <div className="split-layout">
                  <div className="col-md-6 text-section">
                    <p className="content-text">
                    Lance and Morgan cannot wait to explore the island and spend some quality time with smaller groups of friends and family before the wedding.
                    </p>
                    <p className="content-text">
                    No itinerary and no obligations at all. Stay wherever you would like and use this time to explore the island at your own pace. Lance & Morgan envision exploring the villages of Deia and Sollier, hiking up north, and beach days down south with anyone who would like to join. (And for those inclined, sneaking off for a morning of deep water soloing).
                    </p>
                    <p className="content-text">
                    Want to mirror your trip to match the couple's? Their planned itinerary:
                    </p>
                    <ul className="content-text">
                      <li>Saturday 9/26: Fly into Palma & drive to SE coast. Morgan and Lance will be staying at Barefoot Hotel in Portocolom.</li>
                      <li>Sunday 9/27: SE coast</li>
                      <li>Monday 9/28: SE coast</li>
                      <li>Tuesday 9/29: Drive to Port de Soller in the morning, then Soller & NW coast</li>
                      <li>Wednesday 9/30: Soller & NW coast</li>
                      <li>Thursday 10/1: Drive to venue & get the party started (see "fiesta" for further details)</li>
                    </ul>
                    <p className="content-text">
                    Need a hotel, rental car, or activity recommendations? Shoot us a text or ask <Link to="/cashew-ai">CashewAI</Link>. As we get closer to the big trip, we will start a WhatsApp group chat so people can easily get together, send recommendations, etc.
                    </p>
                    <p className="content-text">
                    Trying to meet up while you're here or have questions? Reach us at flotofamily2025@gmail.com or on WhatsApp at 303-927-9365 (Lance) and 508-868-8727 (Morgan).
                    </p>
                  </div>
                  <div className="col-md-6 image-section">
                    <img src="/images/mallorca_beach_1.jpg" alt="Mallorca Beach 1" className="collage-image" />
                    <img src="/images/mallorca_beach_2.jpg" alt="Mallorca Beach 2" className="collage-image" />
                    <img src="/images/mallorca_deia.jpg" alt="Mallorca Deia" className="collage-image" />
                  </div>
                </div>
              )}

              {activeTab === 'fiesta' && (
                <div className="split-layout">
                  <div className="col-md-6 image-section">
                    <img src="/images/eulalia_3.jpg" alt="Eulalia 3" className="img-fluid mb-3" />
                    <img src="/images/eulalia_2.webp" alt="Eulalia 2" className="img-fluid mb-3" />
                    <img src="/images/eulalia_1.webp" alt="Eulalia 1" className="img-fluid mb-3" />
                    <img src="/images/eulalia_pool.jpg" alt="Eulalia Pool" className="img-fluid" />
                  </div>
                  <div className="col-md-6 text-section event-section">
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="card p-3">
                          <h5 className="title-text event-title">Accomodations</h5>
                          
                          <p className="content-text">We have the entirety of our venue rented out from October 1st through October 3rd — 49 rooms just for our wedding celebration! All events are happening here, so staying onsite means total convenience, plus extra pool time, and late-night hangouts.</p>
                          <p className="content-text">Rooms are between $280-400 per night and each accommodates two to four people (we can arrange extra beds if you’re bringing little ones). Price covers taxes, fees, and includes breakfast each morning. </p>
                          <p className="content-text">Room assignments have been sent out. If you did not receive an email, check for an email from "flotofamily2025@gmail.com" or feel free to reach out to the couple.</p>
                          <p className="content-text">If you are staying elsewhere, the city of Can Picafort (10-15 minute drive) has plenty of great options.</p>
                        </div>
                      </div>
                    </div>                    {/* Thursday */}
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="card p-3">
                          <h5 className="title-text event-title">October 1st: Welcome Party</h5>
                          <p className="content-text"><strong>Time:</strong> 6:30 PM - 9:30 PM</p>
                          <p className="content-text"><strong>Location:</strong> Casal Santa Eulalia (Rock Pool)</p>
                          <p className="content-text"><strong>Attire:</strong> Coastal Chic - think linens, pastels, sundresses, sandals and loafers</p>
                          <p className="content-text">Join us for a casual welcome reception with drinks and a paella dinner as we kick off the wedding weekend!</p>
                        </div>
                      </div>
                    </div>

                    {/* Friday */}
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="card p-3">
                          <h5 className="title-text title-text-normal-case event-title">October 2nd: Wedding</h5>
                          <p className="content-text"><strong>Time:</strong> 4:30 PM - 1:00 AM</p>
                          <p className="content-text"><strong>Location:</strong> Casal Santa Eulalia (Olive Grove)</p>
                          <p className="content-text"><strong>Attire:</strong> Cocktail - think long colorful dresses and suits (or whatever makes you feel beautiful, just bring those dancing shoes) </p>
                          <p className="content-text">Join us for a beautiful ceremony followed by dinner and dancing all night! Taking bets who will cry more between Morgan, Lance, and their officiant Oren.</p>
                          <p className="content-text"><em>Children are welcome to join the celebration! On site, complimentary childcare will also be available.</em></p>
                        </div>
                      </div>
                    </div>

                    {/* Saturday */}
                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="card p-3">
                          <h5 className="title-text title-text-normal-case event-title">October 3rd: Pool Party</h5>
                          <p className="content-text"><strong>Time:</strong> 9:00 AM - 11:00 AM</p>
                          <p className="content-text"><strong>Location:</strong> Casal Santa Eulalia (Rock Pool)</p>
                          <p className="content-text"><strong>Attire:</strong> Very Casual - Sunnies and bathing suits </p>
                          <p className="content-text">Join us by the pool to recover from and reminice the night before (channeling the college vibes of laughter filled mornings after a night out).</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Map Section */}
              <div className="row mt-5">
                <div className="col-md-12">
                  <h4 className="title-text text-center mb-3">Location Map</h4>
                  <div className="map-container">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d632614.4756855561!2d2.7300247306521284!3d39.72128274631896!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x129632131a8e94f3%3A0xa35c131e373324f3!2sCasal%20Santa%20Eul%C3%A0lia%20Hotel%20%26%20Restaurant!5e0!3m2!1sen!2sus!4v1756043272180!5m2!1sen!2sus" title="Google Map of Casal Santa Eulalia" width="600" height="450" style={{border:0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>                  </div>
                </div>
              </div>

            </div>
          </div>
          <div className="text-center mt-5">
            <Link to="/rsvp" className="btn-like-tab">Confirm Your Presence</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default EventDetails;
